<template>
  <div style="padding: 20px">
    <div style="margin-bottom: 20px">
    <select-area @areaListId="getAreaListId"/>
      <el-date-picker style="width: 160px;margin-right: 10px"
          v-model="query.grade"
          type="year"
          format="YYYY"
          value-format="YYYY"
          placeholder="请选择届">
      </el-date-picker>
      <el-select
          v-model="query.valueType"
          clearable
          placeholder="有无价值"
          style="width: 160px;margin-right: 10px"
      >
        <el-option label="有价值" :value="1"/>
        <el-option label="无价值" :value="2"/>
      </el-select>
    <el-button type="primary" @click="selectList">搜索</el-button>
      <el-popconfirm @confirm="exportExcel"
                     title="确定要导出吗？"
      >
        <template #reference>
          <el-button type="primary">导出</el-button>
        </template>
      </el-popconfirm>
    </div>
    <el-table v-loading="query.loading"
        :data="tableData"
        border
        style="width: 100%">
      <el-table-column
          prop="stuName"
          label="学生姓名"
          width="180">
      </el-table-column>
      <el-table-column
          label="是否在籍"
          width="180">
        <el-table-column
                         prop="mainActive"
                         label="主卡"
                         width="100">
          <template #default="student">
            {{student.row.mainActive === 1 ? '是':'否'}}
          </template>
        </el-table-column>
        <el-table-column width="100"
                         prop="sendActive"
                         label="副卡">
          <template #default="student">
            {{student.row.sendActive === 1 ? '是':'否'}}
          </template>
        </el-table-column>
        <el-table-column width="100"
                         prop="main298Active"
                         label="引流卡">
          <template #default="student">
            {{student.row.main298Active === 1 ? '是':'否'}}
          </template>
        </el-table-column>
        <el-table-column width="100"
                         prop="send298Active"
                         label="298">
          <template #default="student">
            {{student.row.send298Active === 1 ? '是':'否'}}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column width="100"
          prop="oid"
          label="订单ID">
      </el-table-column>
      <el-table-column width="120"
                       prop="studentGrade"
                       label="届">
      </el-table-column>
      <el-table-column width="180"
          prop="sourceName"
          label="来源">
      </el-table-column>
      <el-table-column width="180"
          prop="coachName"
          label="提交人">
      </el-table-column>
      <el-table-column width="180"
          prop="cardName"
          label="主卡类型">
      </el-table-column>
      <el-table-column width="180"
          prop="money"
          label="金额">
      </el-table-column>
      <el-table-column width="180"
          prop="areaName"
          label="校区">
      </el-table-column>
      <el-table-column width="180"
          prop="closedTime"
          label="收款时间">
      </el-table-column>
      <el-table-column width="180"
          prop="orderCount"
          label="卡数量(忽略是否在籍影响)">
      </el-table-column>
      <el-table-column width="180"
          prop="helpActive"
          label="在籍辅助列">
      </el-table-column>
      <el-table-column width="180"
          prop="mainHelpActive"
          label="正价卡在辅助列">
      </el-table-column>
      <el-table-column width="180"
          prop="openCard"
          label="是否有未开卡">
      </el-table-column>
      <el-table-column width="180"
          prop="nowPriceMoney"
          label="分摊余额">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="query.total"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {selectZJStudentPage,exportZJStudent} from "@/api/user";
import selectArea from "../../components/SelectArea";
export default {
  name: "CadastralStudent",
  components: {
    selectArea
  },
  data() {
    return {
      tableData: [],
      query:{
        areaList:[],
        grade:null,
        total:0,
        valueType:null,
        pageIndex:1,
        pageSize:10,
        loading:false
      }
    }
  },
  methods: {
    exportExcel(){
      if (this.query.areaList.length>0){
        exportZJStudent(this.query);
        this.$message.success("导出中，请前往右上角下载查看！");
      }else{
        this.$message.error("导出必须选择校区！");
      }
    },
    handlePageChange(index){
      this.query.pageIndex = index;
      this.selectList();
    },
    getAreaListId(val) {
      this.query.areaList = val;
    },
    selectList(){
      this.query.loading = true;
      selectZJStudentPage(this.query).then(val=>{
        this.query.loading = false;
        if (val.code === 200) {
          this.tableData = val.data.records;
          this.query.total = val.data.total;
          console.log(this.tableData)
        }
      })
    }
  },
  created() {
    this.selectList();
  }
}
</script>

<style scoped>

</style>